var moduleMap = {
	"./constants": () => {
		return __webpack_require__.e(1841).then(() => (() => ((__webpack_require__(31841)))));
	},
	"./types": () => {
		return __webpack_require__.e(4483).then(() => (() => ((__webpack_require__(4483)))));
	},
	"./utils": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(7830), __webpack_require__.e(8048)]).then(() => (() => ((__webpack_require__(38048)))));
	},
	"./hooks": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(2263), __webpack_require__.e(5011), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(482), __webpack_require__.e(5579), __webpack_require__.e(5667), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(7356), __webpack_require__.e(3457), __webpack_require__.e(8845), __webpack_require__.e(280), __webpack_require__.e(7830), __webpack_require__.e(1357)]).then(() => (() => ((__webpack_require__(81357)))));
	},
	"./Bootstrap": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(2263), __webpack_require__.e(9304), __webpack_require__.e(5011), __webpack_require__.e(41), __webpack_require__.e(5532), __webpack_require__.e(4618), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(482), __webpack_require__.e(5579), __webpack_require__.e(5667), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(7356), __webpack_require__.e(8845), __webpack_require__.e(580)]).then(() => (() => ((__webpack_require__(18271)))));
	},
	"./router": () => {
		return Promise.all([__webpack_require__.e(5579), __webpack_require__.e(9779)]).then(() => (() => ((__webpack_require__(59779)))));
	},
	"./History": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(4762), __webpack_require__.e(7414)]).then(() => (() => ((__webpack_require__(27414)))));
	},
	"./Authorize": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(4762), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(3741)]).then(() => (() => ((__webpack_require__(73741)))));
	},
	"./isAuthorized": () => {
		return Promise.all([__webpack_require__.e(4762), __webpack_require__.e(627)]).then(() => (() => ((__webpack_require__(80627)))));
	},
	"./UnAuthorized": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(6216)]).then(() => (() => ((__webpack_require__(86216)))));
	},
	"./LandingPage": () => {
		return Promise.all([__webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(482), __webpack_require__.e(1674)]).then(() => (() => ((__webpack_require__(91674)))));
	},
	"./GameSelectorUtils": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(4762), __webpack_require__.e(5667), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(3399)]).then(() => (() => ((__webpack_require__(43399)))));
	},
	"./ErrorBoundary": () => {
		return Promise.all([__webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(482), __webpack_require__.e(5667), __webpack_require__.e(8139)]).then(() => (() => ((__webpack_require__(88139)))));
	},
	"./cWrapper": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(548)]).then(() => (() => ((__webpack_require__(50548)))));
	},
	"./Request": () => {
		return Promise.all([__webpack_require__.e(4762), __webpack_require__.e(1295), __webpack_require__.e(3457), __webpack_require__.e(8845), __webpack_require__.e(6096)]).then(() => (() => ((__webpack_require__(46096)))));
	},
	"./Link": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(5579), __webpack_require__.e(6161), __webpack_require__.e(8216)]).then(() => (() => ((__webpack_require__(18216)))));
	},
	"./Selectors": () => {
		return Promise.all([__webpack_require__.e(2263), __webpack_require__.e(8520), __webpack_require__.e(7604)]).then(() => (() => ((__webpack_require__(67604)))));
	},
	"./Analytics": () => {
		return Promise.all([__webpack_require__.e(4306), __webpack_require__.e(5740)]).then(() => (() => ((__webpack_require__(55740)))));
	},
	"./NotFound": () => {
		return Promise.all([__webpack_require__.e(4816), __webpack_require__.e(8397), __webpack_require__.e(2263), __webpack_require__.e(9304), __webpack_require__.e(5011), __webpack_require__.e(5532), __webpack_require__.e(7359), __webpack_require__.e(4762), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(8520), __webpack_require__.e(8454), __webpack_require__.e(5579), __webpack_require__.e(5667), __webpack_require__.e(1295), __webpack_require__.e(2567), __webpack_require__.e(7356), __webpack_require__.e(1131)]).then(() => (() => ((__webpack_require__(91131)))));
	},
	"./ViewOnlyAlert": () => {
		return Promise.all([__webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(482), __webpack_require__.e(9789)]).then(() => (() => ((__webpack_require__(59789)))));
	},
	"./ViewOnlyTooltip": () => {
		return Promise.all([__webpack_require__.e(8397), __webpack_require__.e(9304), __webpack_require__.e(41), __webpack_require__.e(7359), __webpack_require__.e(4582), __webpack_require__.e(8060), __webpack_require__.e(750)]).then(() => (() => ((__webpack_require__(90750)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});